import styled from 'styled-components';
import arrowBlue from '../../../images/arrow-green.png';

export const RightMenuPanelContainer = styled.h2`
  float: left;
  width: 100%;
  @media (max-width: 991px) {
    width: 250px !important;
  }
`;

export const LiContainer = styled.li`
  position: relative;
  z-index: 2;
  margin: 0px;
  padding: 0px;
  list-style: none;
  background: none;
  :hover {
    background: #fff;
  }
`;

export const LinkStyle = styled.a`
  display: block;
  padding: 10px 0 10px 30px;
  font-family: 'Tungsten-Medium', arial, sans-serif;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #255a3a;
  background-size: 7px auto;
  text-decoration: none;
  text-align: left;
  transition: background-position 0.15s ease-out;
  :hover {
    background: url(${arrowBlue})no-repeat -7px 18px;
    background-size: 7px auto;
    background-position: 12px 18px;
    color: #33a23c;
    cursor: pointer;
  }
`;

export const ListContainer = styled.ul`
  margin-left: 0px;
  padding-left: 0px;
  margin-bottom: 0 !important;
`;
